import { render, staticRenderFns } from "./SlotsTimePicker.vue?vue&type=template&id=5dbd5724&lang=pug&"
import script from "./SlotsTimePicker.vue?vue&type=script&lang=js&"
export * from "./SlotsTimePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VDialog,VTextField,VTimePicker})
